import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `EmpresaCentro/editCentro`, method: 'POST', body: values, token: token})
}
